// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Button,
//   Card,
//   CardMedia,
//   CardContent,
//   CardActionArea,
//   Stack,
// } from "@mui/material";
// import { motion } from "framer-motion";

// // Sample Data
// const portfolioData = [
//   { id: 1, category: "Beach", image: "https://via.placeholder.com/300", title: "Beach Wedding" },
//   { id: 2, category: "Traditional", image: "https://via.placeholder.com/300", title: "Traditional Wedding" },
//   { id: 3, category: "Destination", image: "https://via.placeholder.com/300", title: "Destination Wedding" },
//   { id: 4, category: "Beach", image: "https://via.placeholder.com/300", title: "Beach Wedding" },
//   { id: 5, category: "Traditional", image: "https://via.placeholder.com/300", title: "Traditional Wedding" },
//   { id: 6, category: "Destination", image: "https://via.placeholder.com/300", title: "Destination Wedding" },
// ];

// // Filter Categories
// const categories = ["All", "Beach", "Traditional", "Destination"];

// const PortfolioPage = () => {
//   const [selectedCategory, setSelectedCategory] = useState("All");

//   // Filtered Portfolio Items
//   const filteredData =
//     selectedCategory === "All"
//       ? portfolioData
//       : portfolioData.filter((item) => item.category === selectedCategory);

//   return (
//     <Box sx={{ py: 4, px: 2 }}>
//       {/* Header Section */}
//       <Typography
//         variant="h4"
//         align="center"
//         gutterBottom
//         sx={{
//           fontWeight: "bold",
//           mb: 4,
//           textTransform: "uppercase",
//           letterSpacing: 2,
//         }}
//       >
//         Portfolio
//       </Typography>

//       {/* Filter Buttons */}
//       <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 4 }}>
//         {categories.map((category) => (
//           <Button
//             key={category}
//             variant={selectedCategory === category ? "contained" : "outlined"}
//             onClick={() => setSelectedCategory(category)}
//             sx={{
//               textTransform: "capitalize",
//               fontWeight: "bold",
//             }}
//           >
//             {category}
//           </Button>
//         ))}
//       </Stack>

//       {/* Portfolio Grid */}
//       <Grid container spacing={3}>
//         {filteredData.map((item) => (
//           <Grid item xs={12} sm={6} md={4} key={item.id}>
//             <motion.div
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <Card>
//                 <CardActionArea>
//                   <CardMedia
//                     component="img"
//                     height="200"
//                     image={item.image}
//                     alt={item.title}
//                   />
//                   <CardContent>
//                     <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//                       {item.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Category: {item.category}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             </motion.div>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

// export default PortfolioPage;





import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Stack,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";

// Filter Categories
const categories = ["All", "Beach", "Traditional", "Destination"];

const PortfolioPage = () => {
  const [portfolioData, setPortfolioData] = useState([]); // Data fetched from the API
  const [filteredData, setFilteredData] = useState([]); // Data to display based on the selected category
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [openModal, setOpenModal] = useState(false); // Modal open state
  const [selectedItem, setSelectedItem] = useState(null); // Selected item to show in the modal

  // Fetch data from API
  useEffect(() => {
    const fetchPortfolioData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://wedding-backend-pi.vercel.app/api/portfolio"); // Replace with your API URL
        setPortfolioData(response.data); // Assuming the API response is an array of portfolio items
        setFilteredData(response.data); // Initially show all items
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch portfolio data. Please try again.");
        setLoading(false);
      }
    };

    fetchPortfolioData();
  }, []);

  // Handle category selection and filter data
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === "All") {
      setFilteredData(portfolioData);
    } else {
      setFilteredData(
        portfolioData.filter(
          (item) => item.category.toLowerCase() === category.toLowerCase()
        )
      );
    }
  };

  // Open modal with selected item
  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setOpenModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedItem(null);
  };

  return (
    <Box sx={{ py: 4, px: 2 }}>
      {/* Header Section */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          mb: 4,
          textTransform: "uppercase",
          letterSpacing: 2,
        }}
      >
        Portfolio
      </Typography>

      {/* Filter Buttons */}
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 4 }}>
        {categories.map((category) => (
          <Button
            key={category}
            variant={selectedCategory === category ? "contained" : "outlined"}
            onClick={() => handleCategoryChange(category)}
            sx={{
              textTransform: "capitalize",
              fontWeight: "bold",
            }}
          >
            {category}
          </Button>
        ))}
      </Stack>

      {/* Show loading spinner or error message */}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography variant="h6" color="error" align="center">
          {error}
        </Typography>
      ) : (
        <Grid container spacing={3}>
          {/* Portfolio Grid */}
          {filteredData.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Card sx={{ display: "flex", flexDirection: "column" }}>
                  <CardActionArea onClick={() => handleOpenModal(item)}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={item.image}
                      alt={item.title}
                      sx={{
                        objectFit: "cover", // Ensure image fits well
                        width: "100%", // Ensure the image width fills the card
                      }}
                    />
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Category: {item.category}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Modal for detailed view */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>{selectedItem?.title}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CardMedia
              component="img"
              image={selectedItem?.image}
              alt={selectedItem?.title}
              sx={{ width: "100%", height: "auto", mb: 2 }}
            />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {selectedItem?.title}
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              {selectedItem?.description}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Category: {selectedItem?.category}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PortfolioPage;
